import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonService } from 'app/reusable/common.service';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Select, Store } from "@ngxs/store";
import { ResetState, SetDossier, SetDraftDossier} from "app/_actions/intake.actions";
import { IntakeState } from 'app/_state/intake.state';
import { IntakeService } from 'app/intake/intake-services/intake.service';
import { CedNotificationService } from 'ced-ng-library';
import { SharedService } from 'app/_services/shared.service';
import { DOSSIER_STATUS } from 'app/_constants/dossierStatus';
import { environment } from "environments/environment";

@Component({
  selector: 'app-draft-dossier-list',
  templateUrl: './draft-dossier-list.component.html',
  styleUrls: ['./draft-dossier-list.component.scss']
})
export class DraftDossierListComponent implements OnInit, OnDestroy {
  dataSource: any;
  @Select(IntakeState.getIntake) Intake$: Observable<any>;
  private _subject$: Subject<boolean> = new Subject();
  selectedDossier;
  editMode: boolean = false;
  public hasIntakeCreationPermission: boolean = false;
  public serverUrlSlot3 : string = environment.Services.AlphaURLSlot3;

  constructor(
    private commonService: CommonService,
    private store: Store, private sharedService: SharedService,
    private intakeService: IntakeService,
    private cedNotificationService: CedNotificationService
  ) { }

  ngOnInit() {
    this.hasIntakeCreationPermission = this.sharedService.checkPermissionByRole("Intake").hasCreate;
    this.getDraftDossier();
  }

  getDraftDossier() {
    let GetDossierUrl: string = 'Dossier/GetDraftDossierList';
    this.commonService.getData(GetDossierUrl,this.serverUrlSlot3).pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {
        data.forEach(element =>{
          element.status = DOSSIER_STATUS.OPEN;   
          element.incidentDate = this.getLocaleDate(element.incidentDate);
          element.birthDate = element.dateOfBirth!=null? (this.getLocaleDate(element.dateOfBirth)).toString(): "";
          element.inputDate = this.getLocaleDate(element.inputDate);
          element.lastModificationDate = this.getLocaleDate(element.lastModificationDate);
        })
        this.dataSource = data;
      },
      (error) => {
          this.cedNotificationService.error("NOTIFICATIONS.GET_DOSSIER");
      });
  }
  
  getLocaleDate(date: Date) {
    return this.intakeService.getLocalDate(date);
  }

  openDetails(event, gridDossier) {
    let selectedData
    if (event.path) {
      selectedData = gridDossier.data.data[event.path[1].rowIndex];
      this.open(selectedData.dossierId, true)
    } else {
      selectedData = gridDossier.data.data[event.target.parentElement.rowIndex];
    }
  }
 
  startNewIntake() {
    this.store.dispatch(new ResetState()).pipe(takeUntil(this._subject$)).subscribe();
  }

  dblClickEvent() {
    if (this.selectedDossier != null)
      this.open(this.selectedDossier.draftDossierNumber, this.editMode);
    this.selectedDossier = null;
  }

  open(draftDossierNumber, editMode) {
    let GetDossierUrl: string = `Dossier/GetByFakeDossierNumber/` + draftDossierNumber;
    this.commonService.getData(GetDossierUrl, this.serverUrlSlot3).pipe(takeUntil(this._subject$))
      .subscribe(
        (data: any) => {
          data.draftDossierNumber = draftDossierNumber;  
          this.store.dispatch(new SetDraftDossier(data));
        },
        (error) => {
            this.cedNotificationService.error("NOTIFICATIONS.GET_DOSSIER");
        });
  }

  onCellClick($event) {
    this.selectedDossier = $event.dataItem
  }

  ngOnDestroy(): void {
    this._subject$.next();
    this._subject$.complete();
  }
}